import { Storage } from '../../../constants/storage';

const DB_NAME = 'simplize_chat_cache';
const STORE_NAME = 'session_keys';
const DB_VERSION = 1;

const getUserId = () => {
    if (typeof window === 'undefined') return 'guest';
    try {
        const raw = window.localStorage.getItem(Storage.current_user);
        if (raw) {
            const user = JSON.parse(raw);
            if (user && user.id) return String(user.id);
        }
    } catch {
        // ignore
    }
    try {
        return window.localStorage.getItem(Storage.super_agent_user_id) || 'guest';
    } catch {
        return 'guest';
    }
};

const getEffectiveKey = (key) => {
    if (!key) return key;
    return `${getUserId()}:${key}`;
};

function openDB() {
    return new Promise((resolve, reject) => {
        const req = indexedDB.open(DB_NAME, DB_VERSION);
        req.onupgradeneeded = (e) => e.target.result.createObjectStore(STORE_NAME);
        req.onsuccess = (e) => resolve(e.target.result);
        req.onerror = () => reject(req.error);
    });
}

export async function getSessionIdByKey(cacheKey) {
    try {
        const db = await openDB();
        const effectiveKey = getEffectiveKey(cacheKey);
        return new Promise((resolve, reject) => {
            const req = db.transaction(STORE_NAME, 'readonly').objectStore(STORE_NAME).get(effectiveKey);
            req.onsuccess = () => resolve(req.result ?? null);
            req.onerror = () => reject(req.error);
        });
    } catch {
        return null;
    }
}

export async function setSessionIdByKey(cacheKey, sessionId) {
    try {
        const db = await openDB();
        const effectiveKey = getEffectiveKey(cacheKey);
        return new Promise((resolve, reject) => {
            const req = db.transaction(STORE_NAME, 'readwrite').objectStore(STORE_NAME).put(sessionId, effectiveKey);
            req.onsuccess = () => resolve();
            req.onerror = () => reject(req.error);
        });
    } catch {
        // ignore
    }
}
